import { ArrowLink } from '@app/components';
import { useEnhancedTranslation } from '@app/hooks';
import cx from 'classnames';
import { FC } from 'react';

import './page-navbar.scss';
import '@app/index.scss';

export type PageNavbarProps = {
  title?: string | null;
  backText?: string | null;
  linkForward?: string | null;
  forwardText?: string | null;
  className?: string;
};

export const PageNavbar: FC<PageNavbarProps> = ({ title, backText, linkForward, forwardText, className }) => {
  const { t } = useEnhancedTranslation({ keyPrefix: 'common' });
  return (
    <nav className={cx(className, 'page-navbar')}>
      <ArrowLink relative="path" size={{ text: 'medium', icon: 'small' }} className="page-navbar__link-back" to="..">
        {backText || t('back')}
      </ArrowLink>
      {title && <p className="page-navbar__title">{title}</p>}
      {!!(forwardText && linkForward) && (
        <ArrowLink size={{ text: 'medium', icon: 'small' }} className="page-navbar__link-forward" to={linkForward}>
          {forwardText}
        </ArrowLink>
      )}
    </nav>
  );
};
